// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2QCwO","text":"Loader_text__oLT3T","loaderAlertWrapper":"Loader_loaderAlertWrapper__1Tf8X"};